<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M0 0h20v20H0z" style="fill:#5757d9;opacity:.002" fill="currentColor"/><path d="M0 13a1 1 0 0 1-1-1v-1.546a1 1 0 0 1 1-1h4.923a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1zm8.077 0a1 1 0 0 1-1-1v-1.546a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1zm0-4.727a1 1 0 0 1-1-1V5.728a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v1.545a1 1 0 0 1-1 1zM0 8.273a1 1 0 0 1-1-1V5.728a1 1 0 0 1 1-1h4.923a1 1 0 0 1 1 1v1.545a1 1 0 0 1-1 1zm8.077-4.727a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v1.545a1 1 0 0 1-1 1z" style="fill:#517dfb" transform="translate(4 4)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-widget-cost',
});
</script>
